import { Column2 } from "@/ui2/atoms/(table)/Column";
import { TableHeader2 } from "@/ui2/molecules/(table)/TableHeader";

type Column = {
  id: string;
  label: string;
};

const COLUMNS = [
  { id: "name", label: "Patient Name" },
  { id: "noteState", label: "Status" },
  { id: "dateOfService", label: "Date of Service" },
  { id: "lastUpdated", label: "Last Updated" },
  { id: "action", label: "" },
] as const satisfies Column[];

export function DraftNotesTableHeader() {
  return (
    <TableHeader2 className="tw:border-t-0">
      {COLUMNS.map((col, i) => (
        <Column2 id={col.id} isRowHeader={i === 0} key={col.id}>
          {col.label}
        </Column2>
      ))}
    </TableHeader2>
  );
}
